import {
  getAPIFilters,
  getValueFilters,
  handleRequestFiltersChange
} from "PFApp/use_filtered_collection/format_filters";
import { LoadingDots } from "PFComponents/loading_dots";
import { fetchPaginatedCollection } from "PFCore/helpers/collection";
import { useDeterministicStringify } from "PFCore/helpers/use_deterministic_stringity";
import { ApiRoute } from "PFCore/utilities/routes";
import React, { useCallback, useEffect, useState } from "react";

import UsersPage from "./users_page";

const UsersController = () => {
  const [users, setUsers] = useState(null);
  const [order, setOrder] = useState("");
  const [pending, setPending] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [filters, setFilters] = useState({});
  const [requestFilters, setRequestFilters] = useState({});
  const stringify = useDeterministicStringify();

  const fetchAll = useCallback(() => {
    setPending(true);

    const params = {
      page: currentPage,
      filters: getAPIFilters(requestFilters)
    };

    if (order) {
      params.sort = order;
    }

    fetchPaginatedCollection(ApiRoute("/api/admin/profiles"), params).then((collection) => {
      setUsers(collection.entries);

      setFilters(collection.meta.filters);
      setRequestFilters(getValueFilters(collection.meta.filters));

      setTotalPages(collection.meta.totalPages);
      setTotal(collection.meta.total);
      setPending(false);
    });
  }, [order, currentPage, stringify(getAPIFilters(requestFilters))]);

  useEffect(() => {
    fetchAll();
  }, [order, currentPage, stringify(getAPIFilters(requestFilters))]);

  const applySort = useCallback(
    (name) => {
      if (order === `${name}.asc`) {
        setOrder(`${name}.desc`);
      } else {
        setOrder(`${name}.asc`);
      }
    },
    [order]
  );

  const handleFilterChange = (filter, value) => {
    const newFilters = handleRequestFiltersChange(requestFilters, filter, value);
    setRequestFilters(newFilters);
    setCurrentPage(1);
  };

  if (!users) {
    return <LoadingDots circlesEnabled pageViewEnabled />;
  }

  const clearFilters = () => setRequestFilters({});

  return (
    <UsersPage
      users={users}
      filters={filters}
      requestFilters={requestFilters}
      fetchAll={fetchAll}
      applySort={applySort}
      order={order}
      pending={pending}
      currentPage={currentPage}
      total={total}
      totalPages={totalPages}
      handlePageChange={setCurrentPage}
      handleFilterChange={handleFilterChange}
      clearFilters={clearFilters}
    />
  );
};

export default UsersController;
